/**
 * Created by andrii on 5/16/17.
 */
;(function (obj) {
    function setCityIdToAnchor(location) {
        $('a.other-widget').each(function () {
            var $a_elm = $(this);
            var href = $a_elm.attr('href');
            var location_param = getUrlParameter($a_elm.get(0), 'location');
            if ('' == location_param) {
                href += '?location=' + location;
            } else {
                href = href.replace('?location=' + location_param, '?location=' + location);
            }
            $a_elm.attr({href: href});
        });
    }

    function getUrlParameter(url, name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(url.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function updateWidgetPreview() {
        this.collectWidgetParams();
        var preview_url = this.getPreviewUrl() + '?' + $.param(this._widget_params) + '&preview=1';
        this._preview_frame.attr({src: preview_url});
    }

    function updateAnalogWidgetPreview() {
        this.collectWidgetParams();
        var preview_url = this.getPreviewUrl() + '?' + $.param(this._widget_params) + '&preview=1';
        this._preview_frame.attr({src: preview_url});

        var size = this._widget_params['size'];
        this._preview_frame.width(parseInt(size, 10) + 75);
        this._preview_frame.height(parseInt(size, 10) + 75);

    }

    function getAnalogPreviewUrl() {
        return '/free-clocks/get-code-analog';
    }

    function getTextPreviewUrl() {
        return '/free-clocks/get-code-text';
    }

    function getDigitalPreviewUrl() {
        return '/free-clocks/get-code-digital';
    }

    function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    function getLocationObj()
    {
        var location_id = this._widget_elements['location'].val(),
            location_name = '', location_name_parts;
        if(location_id && this._widget_elements['location'].find('option:selected').length > 0) {
            location_name = this._widget_elements['location'].find('option:selected').text();
            location_name_parts = location_name.split(',');
            return {'id': location_id, 'name': location_name_parts[0] };
        } else {
            return {};
        }
    }

    function collectWidgetParams() {
        for (var p_name in this._widget_elements) {
            this._widget_params[p_name] = this._widget_elements[p_name].val();
        }
    }

    function updateWidgetCode() {
        var self = this;
        var $widget_code_el = $('#widget-code');
        $widget_code_el.text('');
        self.collectWidgetParams();
        if(!validateUrl(self._widget_elements['user_website'].val())) {
            hideCodeWrapper();
            showError('user_website');
        } else {
            hideError('user_website');
        }

        if ($widget_code_el.is(':visible')) {
            $.ajax({
                dataType: 'json',
                data: self._widget_params,
                url: self.getPreviewUrl(),
                beforeSend: function() {
                    hideCodeWrapper();
                    $('#widget-loader').show();
                },
                success: function (data) {
                    $('#widget-code').text(data['widget_code']);
                    $('#widget-loader').hide();
                    showCodeWrapper();
                }
            });
        }
    }

    function checkSelectedLocation(location_id) {
        if(location_id.indexOf('tz') === 0) {
            if('showtimezone' in this._widget_elements) {
                this._widget_elements['showtimezone'].parent().css({'display': 'none'});
            }
        } else {
            if('showtimezone' in this._widget_elements) {
                this._widget_elements['showtimezone'].parent().css({'display': 'block'});
            }
        }
    }

    var ANCHOR_CLASS = 'a-suggest';
    function getSuggestionAnchor(anchor_text) {
        return '<a href="javascript:void(0);" class="grey ' + ANCHOR_CLASS + '">' + anchor_text + "</a>"
    }

    function getAnchorText(pattern, location) {
        if(location['id'].indexOf('tz') === 0) {
            var matches = location['name'].match(/\((\w+)\)/);
            if(matches.length > 0) {
                return pattern.replace('%location%', matches[1]);
            } else {
                return pattern.replace('%location%', location['name']);
            }
        } else {
            return pattern.replace('%location%', location['name']);
        }
    }

    function AnchorTextSuggester(options) {
        var self = this;
        this._container = ('container' in options) ? options['container'] : null;
        this._onSelectSuggest = ('onSelectSuggest' in options) ? options['onSelectSuggest']: null;
        this._language = 'en';
        this._location = {};

        this._container.find('.' + ANCHOR_CLASS).on('click', function (e) {
            if(typeof self._onSelectSuggest === 'function'){
                self._onSelectSuggest.call(null, $(this).text());
            }
        });
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function validateUrl(value)
    {
        return /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test( value );
    }

    function showError(element_name) {
        $('#' + element_name + '_errors').show();
    }

    function hideError(element_name) {
        $('#' + element_name + '_errors').hide();
    }

    function showCodeWrapper() {
        $('#widget-code-wrapper').show();
    }

    function hideCodeWrapper() {
        $('#widget-code-wrapper').hide();
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }
        return a;
    }


    AnchorTextSuggester.prototype.setLocation = function (location) {
        this._location = location;
    };

    AnchorTextSuggester.prototype.setLanguage = function (lang) {
        this._language = lang;
    };

    AnchorTextSuggester.prototype.updateSuggestions = function (callback) {
        var self = this, anchor_text = '', suggestion_anchors = [];
        this._container.empty();

        $.ajax({
            url : '/free-clocks/anchor-suggests',
            dataType: 'json',
            data: {
                location: self._location['id'],
                lang: self._language
            },
            success: function (data) {
                var suggestions = ('suggestions' in data) ? data['suggestions'] : [],
                    suggestion_anchors = [];
                for(var i = 0, j = suggestions.length; i < j; i++) {
                    suggestion_anchors.push('<a href="javascript:void(0);" class="grey ' + ANCHOR_CLASS + '">' + suggestions[i] + '</a>');
                }

                if(suggestion_anchors.length > 0) {
                    self._container.html(suggestion_anchors.join(', '));
                    self._container.find('.' + ANCHOR_CLASS).on('click', function (e) {
                        if(typeof self._onSelectSuggest === 'function'){
                            self._onSelectSuggest.call(null, $(this).text());
                        }
                    });
                }
                if(typeof callback == 'function') {
                    callback(suggestions);
                }
            }
        });
    };

    function AnalogWidgetGenerator(options) {
        /*
         Widget options: size, lang, bgcolor, location
         */
        var self = this;
        this._options = options;
        this._widget_elements = {
            'location': $('#location'),
            'size': $('#size'),
            'bgcolor': $('#color'),
            'language': $('#language'),
            'anchor_text' : $('#anchor_text'),
            'user_website': $('#user_website')
        };
        this._preview_frame = $('iframe#widget-preview');
        this._widget_params = {};

        this._text_suggester = new AnchorTextSuggester({
            container: $('#anchor-text-suggests'),
            onSelectSuggest: function (suggest_text) {
                var old_value = self._widget_elements['anchor_text'].val();
                self._widget_elements['anchor_text'].val(suggest_text);
                if(old_value != suggest_text) {
                    self._widget_elements['anchor_text'].trigger('change');
                }
            }
        });
        this._text_suggester.setLanguage(this._widget_elements['language'].val());
        this._text_suggester.setLocation(this.getLocationObj());

        (function () {
            checkSelectedLocation.call(self, self._widget_elements['location'].val());
            self.updateWidgetPreview();
        })();
    }

    AnalogWidgetGenerator.prototype.collectWidgetParams = collectWidgetParams;
    AnalogWidgetGenerator.prototype.updateWidgetPreview = updateAnalogWidgetPreview;
    AnalogWidgetGenerator.prototype.getPreviewUrl = getAnalogPreviewUrl;
    AnalogWidgetGenerator.prototype.updateWidgetCode = updateWidgetCode;
    AnalogWidgetGenerator.prototype.getLocationObj = getLocationObj;
    AnalogWidgetGenerator.prototype.setup = function () {
        var self = this,
            _timeout = null;

        this._widget_elements['location'].on('change', function (e) {
            var location_id = $(this).val();
            setCityIdToAnchor(location_id);
            checkSelectedLocation.call(self, location_id);

            self._text_suggester.setLocation(self.getLocationObj());
            self._text_suggester.updateSuggestions(function (suggestions) {
                var idx = getRandomInt(0, suggestions.length);
                self._widget_elements['anchor_text'].val(suggestions[idx]);
                self.updateWidgetPreview.call(self);
                self.updateWidgetCode.call(self);
            });

        });

        this._widget_elements['size'].on('change', function (e) {
            self.updateWidgetPreview.call(self);
            self.updateWidgetCode.call(self);
        });

        this._widget_elements['bgcolor'].on('change', function (e) {
            self.updateWidgetPreview.call(self);
            self.updateWidgetCode.call(self);
        });

        this._widget_elements['language'].on('change', function (e) {
            self._text_suggester.setLanguage($(this).val());
            self._text_suggester.updateSuggestions(function (suggestions) {
                var idx = getRandomInt(0, suggestions.length);
                self._widget_elements['anchor_text'].val(suggestions[idx]);
                self.updateWidgetPreview.call(self);
                self.updateWidgetCode.call(self);
            });

        });

        this._widget_elements['anchor_text'].on('change', function (e) {
            self.updateWidgetPreview.call(self);
            self.updateWidgetCode.call(self);
        });

        this._widget_elements['anchor_text'].on('keyup', function (e) {
            if(null !== _timeout) { clearTimeout(_timeout); }
            _timeout = setTimeout(function() {
                self.updateWidgetPreview.call(self);
                self.updateWidgetCode.call(self);
            }, 1500);
        });

        this._widget_elements['user_website'].on('change', function (e) {
            var field_value = $(this).val();
            if(validateUrl(field_value)) {
                hideError('user_website');
            } else {
                showError('user_website');
                hideCodeWrapper();
            }
        });

        this._widget_elements['user_website'].on('keyup', debounce(function (e) {
            var field_value = $(this).val();
            if(validateUrl(field_value)) {
                hideError('user_website');
            } else {
                showError('user_website');
                hideCodeWrapper();
            }
        }, 150));

        $.fn.select2.amd.define('select2/data/extended-ajax',['./ajax','../utils','jquery'], function(AjaxAdapter, Utils, $){

            function ExtendedAjaxAdapter ($element,options) {
                //we need explicitly process minimumInputLength value
                //to decide should we use AjaxAdapter or return defaultResults,
                //so it is impossible to use MinimumLength decorator here
                this.minimumInputLength = options.get('minimumInputLength');
                this.defaultResults     = options.get('defaultResults');

                ExtendedAjaxAdapter.__super__.constructor.call(this,$element,options);
            }

            Utils.Extend(ExtendedAjaxAdapter,AjaxAdapter);

            //override original query function to support default results
            var originQuery = AjaxAdapter.prototype.query;

            ExtendedAjaxAdapter.prototype.query = function (params, callback) {
                var defaultResults = (typeof this.defaultResults == 'function') ? this.defaultResults.call(this) : this.defaultResults;
                if (defaultResults && defaultResults.length && (!params.term || params.term.length < this.minimumInputLength)){
                    var processedResults = this.processResults(defaultResults,params.term);
                    callback(processedResults);
                }
                else {
                    originQuery.call(this, params, callback);
                }
            };

            return ExtendedAjaxAdapter;
        });

        this._widget_elements['location'].select2({
            placeholder: 'Select an option',
            minimumInputLength: 1,
            dataAdapter:  $.fn.select2.amd.require('select2/data/extended-ajax'),
            ajax: {
                url: self._options['suggest_url'],
                dataType: 'json',
                delay: 100,
                data: function (params) {
                    // Query parameters will be ?search=[term]&page=[page]
                    return {
                        term: params.term,
                        lang: self._widget_elements['language'].val()
                    };
                },
                processResults: function (data, params) {
                    return { results: data.items };
                },
                cache: true
            }
        });

        var tippy_btn = document.querySelector('.tippy');
        tippy(tippy_btn , {'trigger': 'manual', 'placement': 'right', 'offset': '-5, 0'});

        var clipboard = new Clipboard('.copy-to-clipboard', {});
        clipboard.on('success', function (e) {
            dataLayer.push({'event': 'copy-widget-code'});
            setTimeout(function () {
                tippy_btn._tippy.show();
                $.post('/free-clocks/copied', extend(extend({}, self._widget_params), {'widget_type': 'analog'}));
            }, 50);
        });

        $('#terms-of-use-link').on('click', function (e) {
            $('#terms-of-usage').fadeIn();
            e.preventDefault();
        });

        $('form#widget-code-generator').on('submit', function (e) {
            if (validateUrl(self._widget_elements['user_website'].val())) {
                hideError('user_website');
                showCodeWrapper();
                self.updateWidgetCode.call(self);
                dataLayer.push({'event': 'get-widget-code'});
                window.location.hash = "#widget-code";
            } else {
                showError('user_website');
                hideCodeWrapper();
            }
            e.stopPropagation();
            e.preventDefault();
        });

    };

    function TextWidgetGenerator(options) {
        /*
         Widget options: location, hourtype, showdate, showseconds, language
         */
        var self = this;
        this._options = options;
        this._widget_elements = {
            'location': $('#location'),
            'hourtype': $('#hourtype'),
            'showdate': $('#showdate'),
            'showseconds': $('#showseconds'),
            'language': $('#language'),
            'showtimezone' : $('#showtimezone'),
            'size': $('#size'),
            'anchor_text' : $('#anchor_text'),
            'user_website': $('#user_website')
        };
        this._preview_frame = $('iframe#widget-preview');
        this._widget_params = {};

        this._text_suggester = new AnchorTextSuggester({
            container: $('#anchor-text-suggests'),
            onSelectSuggest: function (suggest_text) {
                var old_value = self._widget_elements['anchor_text'].val();
                self._widget_elements['anchor_text'].val(suggest_text);
                if(old_value != suggest_text) {
                    self._widget_elements['anchor_text'].trigger('change');
                }
            }
        });
        this._text_suggester.setLanguage(this._widget_elements['language'].val());
        this._text_suggester.setLocation(this.getLocationObj());

        (function () {
            checkSelectedLocation.call(self, self._widget_elements['location'].val());
            self.updateWidgetPreview();
        })();
    }

    TextWidgetGenerator.prototype.collectWidgetParams = collectWidgetParams;
    TextWidgetGenerator.prototype.updateWidgetPreview = updateWidgetPreview;
    TextWidgetGenerator.prototype.getPreviewUrl = getTextPreviewUrl;
    TextWidgetGenerator.prototype.updateWidgetCode = updateWidgetCode;
    TextWidgetGenerator.prototype.getLocationObj = getLocationObj;
    TextWidgetGenerator.prototype.setup = function () {
        var self = this,
            _timeout = null;

        this._widget_elements['location'].on('change', function (e) {
            var location_id = $(this).val();
            setCityIdToAnchor(location_id);
            checkSelectedLocation.call(self, location_id);
            self._text_suggester.setLocation(self.getLocationObj());
            self._text_suggester.updateSuggestions(function (suggestions) {
                var idx = getRandomInt(0, suggestions.length);
                self._widget_elements['anchor_text'].val(suggestions[idx]);
                self.updateWidgetPreview.call(self);
                self.updateWidgetCode.call(self);
            });
        });

        this._widget_elements['hourtype'].on('change', function (e) {
            self.updateWidgetPreview.call(self);
            self.updateWidgetCode.call(self);
        });

        this._widget_elements['showdate'].on('change', function (e) {
            self.updateWidgetPreview.call(self);
            self.updateWidgetCode.call(self);
        });

        this._widget_elements['showseconds'].on('change', function (e) {
            self.updateWidgetPreview.call(self);
            self.updateWidgetCode.call(self);
        });

        this._widget_elements['language'].on('change', function (e) {
            self._text_suggester.setLanguage($(this).val());
            self._text_suggester.updateSuggestions(function (suggestions) {
                var idx = getRandomInt(0, suggestions.length);
                self._widget_elements['anchor_text'].val(suggestions[idx]);
                self.updateWidgetPreview.call(self);
                self.updateWidgetCode.call(self);
            });
        });

        this._widget_elements['showtimezone'].on('change', function (e) {
            self.updateWidgetPreview.call(self);
            self.updateWidgetCode.call(self);
        });

        this._widget_elements['size'].on('change', function (e) {
            self.updateWidgetPreview.call(self);
            self.updateWidgetCode.call(self);
        });

        this._widget_elements['anchor_text'].on('change', function (e) {
            self.updateWidgetPreview.call(self);
            self.updateWidgetCode.call(self);
        });

        this._widget_elements['anchor_text'].on('keyup', function (e) {
            if(null !== _timeout) { clearTimeout(_timeout); }
            _timeout = setTimeout(function() {
                self.updateWidgetPreview.call(self);
                self.updateWidgetCode.call(self);
            }, 1500);
        });

        this._widget_elements['user_website'].on('change', function (e) {
            var field_value = $(this).val();
            if(validateUrl(field_value)) {
                hideError('user_website');
            } else {
                showError('user_website');
                hideCodeWrapper();
            }
        });

        this._widget_elements['user_website'].on('keyup', debounce(function (e) {
            var field_value = $(this).val();
            if(validateUrl(field_value)) {
                hideError('user_website');
            } else {
                showError('user_website');
                hideCodeWrapper();
            }
        }, 150));

        $.fn.select2.amd.define('select2/data/extended-ajax',['./ajax','../utils','jquery'], function(AjaxAdapter, Utils, $){

            function ExtendedAjaxAdapter ($element,options) {
                //we need explicitly process minimumInputLength value
                //to decide should we use AjaxAdapter or return defaultResults,
                //so it is impossible to use MinimumLength decorator here
                this.minimumInputLength = options.get('minimumInputLength');
                this.defaultResults     = options.get('defaultResults');

                ExtendedAjaxAdapter.__super__.constructor.call(this,$element,options);
            }

            Utils.Extend(ExtendedAjaxAdapter,AjaxAdapter);

            //override original query function to support default results
            var originQuery = AjaxAdapter.prototype.query;

            ExtendedAjaxAdapter.prototype.query = function (params, callback) {
                var defaultResults = (typeof this.defaultResults == 'function') ? this.defaultResults.call(this) : this.defaultResults;
                if (defaultResults && defaultResults.length && (!params.term || params.term.length < this.minimumInputLength)){
                    var processedResults = this.processResults(defaultResults,params.term);
                    callback(processedResults);
                }
                else {
                    originQuery.call(this, params, callback);
                }
            };

            return ExtendedAjaxAdapter;
        });

        this._widget_elements['location'].select2({
            placeholder: 'Select an option',
            minimumInputLength: 1,
            dataAdapter:  $.fn.select2.amd.require('select2/data/extended-ajax'),
            ajax: {
                url: self._options['suggest_url'],
                dataType: 'json',
                delay: 100,
                data: function (params) {
                    // Query parameters will be ?search=[term]&page=[page]
                    return {
                        term: params.term,
                        lang: self._widget_elements['language'].val()
                    };
                },
                processResults: function (data, params) {
                    return { results: data.items };
                },
                cache: true
            }
        });

        var tippy_btn = document.querySelector('.tippy');
        tippy(tippy_btn , {'trigger': 'manual', 'placement': 'right', 'offset': '-5, 0'});
        var clipboard = new Clipboard('.copy-to-clipboard', {});
        clipboard.on('success', function (e) {
            dataLayer.push({'event': 'copy-widget-code'});
            setTimeout(function () {
                tippy_btn._tippy.show();
                $.post('/free-clocks/copied', extend(extend({}, self._widget_params), {'widget_type': self instanceof DigitalWidgetGenerator ?  'digital' : 'text'}));
            }, 50);
        });

        $('#terms-of-use-link').on('click', function (e) {
            $('#terms-of-usage').fadeIn();
            e.preventDefault();
        });

        $('form#widget-code-generator').on('submit', function (e) {
            if (validateUrl(self._widget_elements['user_website'].val())) {
                hideError('user_website');
                showCodeWrapper();
                self.updateWidgetCode.call(self);
                dataLayer.push({'event': 'get-widget-code'});
                window.location.hash = "#widget-code";
            } else {
                showError('user_website');
                hideCodeWrapper();
            }
            e.stopPropagation();
            e.preventDefault();
        });
    };

    function DigitalWidgetGenerator(options) {
        TextWidgetGenerator.call(this, options);
    }

    DigitalWidgetGenerator.prototype = Object.create(TextWidgetGenerator.prototype);
    DigitalWidgetGenerator.prototype.constructor = DigitalWidgetGenerator;
    DigitalWidgetGenerator.prototype.getPreviewUrl = getDigitalPreviewUrl;

    obj.AnalogWidgetGenerator = AnalogWidgetGenerator;
    obj.TextWidgetGenerator = TextWidgetGenerator;
    obj.DigitalWidgetGenerator = DigitalWidgetGenerator;
})(window);